<template>
    <div class="box" :class="NewYear?'boxYear':''">
        <div class="line">
            <img v-if="NewYear" src="../assets/image/newyear/common-header.png" style="width: 329px;height: 40px;">
            <img v-else src="../assets/image/common-header.png" alt="">
        </div>
        <div class="tabline" :class="NewYear?'tablineYear':''">
            <div class="tab-item hover"  v-for="(item, index) in navList" :key="index"
                :class="{ 'active': act_nav == item.id,'hide':!item.show}" @click="changeSystem(item)">
                {{ item.name }}
            </div>
        </div>
        <div class="line2" :class="NewYear?'line2Year':''">
            <div class="user avatar-handel">
                <img class="user-avatar" :src="$store.state.userimage ? $store.state.userimage : require('../assets/image/user.jpg')" alt="" style="border-radius: 50%;">
                <el-popover placement="bottom" title="" width="96" popper-class="showbox hover" trigger="hover">
                    <div class="showbox">
                        <!-- <div v-for="(item, index) in mineList" :key="index" class="showbox-list" @click.stop="toPage(item)">
                            {{ item.name }}
                        </div> -->
                        <div class="showbox-list" @click="toPersonal">个人中心</div>

                        <div @click="logout" class="showbox-list">退出登录</div>
                    </div>
                    <button class="button hover" :class="NewYear?'sjys':''" slot="reference">{{ info.name }}</button>
                </el-popover>
                <local-svg class="user-show hover" :class="NewYear?'sjys':''" iconClass="admindown"></local-svg>
            </div>
            <div class="iconlist">
                <div>
                    <a class="handel" @click="examine">
                        <el-badge :value="totalMessage" :max="999" class="item hover"
                            :hidden="totalMessage == 0 ? true : false">
                            <local-svg class="list-image msg hover " iconClass="msg"></local-svg>
                        </el-badge>
                    </a>
                </div>
                <!-- <div>
                    <a @click="cleanTab()" class="handel">
                        <local-svg class="list-image hover " iconClass="clean"></local-svg>
                    </a>
                </div>
                <div>
                    <a @click="refsh" class="handel">
                        <local-svg class="list-image hover " iconClass="newload"></local-svg>
                    </a>
                </div> -->
                <!-- <div class="more-box" v-if="moreList.length > 0">
                    <el-popover placement="bottom" title="" width="96" popper-class="showbox hover" trigger="hover">
                        <div class="showbox">
                            <div v-for="(item, index) in moreList" :key="index" class="showbox-list"
                                @click.stop="toPage(item)">
                                {{ item.name }}
                            </div>
                        </div>
                        <button class="button hover" slot="reference">
                            <local-svg class="list-image hover handel" iconClass="more"></local-svg>
                        </button>
                    </el-popover>
                </div> -->
            </div>
        </div>
        <el-drawer :visible.sync="messageDialog" :with-header="false" class="messageBox" append-to-body @close="closeDrawer">
            <div class="message-info">
                <div class="msg-header" style="flex: none;">
                    <div class="headtab">
                        <div class="tab-box hover">
                            <div class="tab" v-for="(item, index) in msgTabList" :key="index"
                                :class="{ 'acttab': actMsgIndex == index }" @click="changTab(index)">
                                <el-badge :value="item.num" :max="999" class="item"
                                    :hidden="item.num == 0 ? true : false">{{
                                        item.name }}</el-badge>
                            </div>
                        </div>
                    </div>
                </div>
                <template>
                    <div style="flex: none;" class="select-part addform header-cascader" v-if="actMsgIndex == 0">
                        <el-cascader placeholder="请选择" :options="typeList" collapse-tags v-model="form.type"
                            :props="{ value: 'type', multiple: true, label: 'title', children: 'chid', checkStrictly: true }" popper-class="header-cascader-option"
                            filterable clearable style="width: 100%;" @change="getMsg('select')">
                        </el-cascader>
                    </div>
                </template>
                <div class="msg-list first-page" v-if="actMsgIndex == 0">
                    
                    <div v-for="(item, index) in msgList" :key="index" class="msg hover"
                        @click="toExamine(item.data_id, item.type_id, item)" >
                        <div class="msg-top">
                            <div class="msg-title">
                                <div v-show="item.is_read == '未读'" class="msg-point"></div>
                                {{ item.type_id == 1 ? '合同管理' : item.type_id == 2 ? '回款记录' : item.type_id == 3 ? '成本支出' : item.type_id == 4 ? '房屋回款' : item.type_id == 5 ? '成本支出-未提交票据' :
                                 item.type_id == 6 ? '成本支出-确认提交票据' : item.type_id == 7 ? '开票管理' : item.type_id == 10 ? '完善开票回款' : item.type_id == 11 ? '完善房号信息' : item.type_id == 12? '更新客户名称' :
                                 item.type_id == 13 ? '房号提醒' : item.type_id == 14 && item.source == 1? '新建外勤工单' : item.type_id == 14  && item.source == 2 ? '新建内部服务' : item.type_id == 15  && item.source == 1? '外勤工单流转':item.type_id == 15  && item.source == 2? '内部服务流转' : item.type_id == 16 ? '问题反馈' : item.type_id == 17&& item.source == 1 ? '外勤工单驳回' : item.type_id == 17&& item.source == 2 ? '内部服务驳回' : item.type_id == 23 || item.type_id == 24?'客户管理-更新客户名称':item.type_id == 25?'用户注册':
                                 item.type_id==27?'我的需求':item.type_id==26?'完善房号回款单号':item.type_id==28?'专事专办':item.type_id==29?'确认房号回款':item.type_id==31?'项目工程':item.type_id==33?'行政支出-未提交票据':item.type_id==35?'完善成本支出回款':item.type_id==34?'行政支出-确认提交票据':item.type_id==32?'行政支出':item.type_id==36?'房号合同确认':item.type_id==37?'房号确认后流转外勤工单':item.type_id==38?'房屋合同':item.type_id==39?'完善续签房号地址':item.type_id==40?'完善合同附件':'测试' }}
                            </div>
                            <span class="msg-date">{{ item.create_time }}</span>
                        </div>
                        <div class="msg-main" v-if="item.type_id == 5">{{ item.num }}该笔成本支出未提交相关票据</div>
                        <div class="msg-main" v-else-if="item.type_id == 6">{{ item.first_admin.name }}发起的{{ item.num }}已提交相关票据，请及时处理
                        </div>
                        <div class="msg-main" v-else-if="item.type_id == 11">{{ item.admin }}提交{{item.num}}了的房号单据，请及时完善</div>
                        <div class="msg-main" v-else-if="item.type_id == 24">{{ item.admin }}在【{{item.num}}】提交了营业执照，请判断是否更新客户名称</div>
                        <div class="msg-main" v-else-if="item.type_id == 14 && item.source == 1">{{ item.admin }}提交了外勤【{{ item.num }}】，请及时审核</div>
                        <div class="msg-main" v-else-if="item.type_id == 14 && item.source == 2">{{ item.admin }}提交的【{{ item.num }}】，请及时审核</div>
                        <div class="msg-main" v-else-if="item.type_id == 15 && item.source == 1">{{ item.admin }}流转了外勤【{{ item.num }}】的审批，请及时处理</div>
                        <div class="msg-main" v-else-if="item.type_id == 15 && item.source == 2">{{ item.admin }}流转了{{ item.create_user }}提交的【{{ item.num }}】，请及时处理</div>
                        <div class="msg-main" v-else-if="item.type_id == 16">{{ item.admin }}进行了外勤【{{ item.num }}】问题反馈，请及时处理</div>
                        <div class="msg-main" v-else-if="item.type_id == 17 && item.source == 1">{{ item.admin }}驳回了【{{ item.num }}】的外勤工单，请及时修改</div>
                        <div class="msg-main" v-else-if="item.type_id == 17 && item.source == 2">{{ item.admin }}驳回了{{ item.create_user }}提交的【{{ item.num }}】，请及时修改</div>
                        <div class="msg-main" v-else-if="item.type_id == 18">{{ item.admin }}外勤【{{ item.num }}】已延期，请及时填写延期原因</div>
                        <div class="msg-main" v-else-if="item.type_id == 23">若"{{item.client}}"不为渠道，请及时修改企业名称！</div>
                        <div class="msg-main" v-else-if="item.type_id == 25">{{ item.admin }}提交用户注册，请及时审核人员信息</div>
                        <div class="msg-main" v-else-if="item.type_id == 27">{{ item.admin }}流转给你【{{ item.num }}】{{item.need_name}}：{{ item.des }}！</div>
                        <div class="msg-main" v-else-if="item.type_id == 26">请完善【{{item.num}}】生成的房号的回款单号！</div>
                        <div class="msg-main" v-else-if="item.type_id == 28">{{ item.admin }}流转了{{item.create_user}}提交的【{{item.num}}】的专事专办，请及时处理</div>
                        <div class="msg-main" v-else-if="item.type_id == 29">{{ item.admin }}提交了【{{item.num}}】，请及时确认房号地址</div>
                        <div class="msg-main" v-else-if="item.type_id == 31">{{ item.admin }}上传了工程，请及时更新!</div>
                        <div class="msg-main" v-else-if="item.type_id == 32">{{ item.first_admin.name }}提交了行政支出【{{ item.num }}】审批，请及时处理!</div>
                        <div class="msg-main" v-else-if="item.type_id == 33">{{ item.num }}该笔行政支出未提交相关票据!</div>
                        <div class="msg-main" v-else-if="item.type_id == 34">{{ item.first_admin.name }}发起的【{{ item.num }}】已提交相关票据，请及时处理</div>
                        <div class="msg-main" v-else-if="item.type_id == 35">请及时完善【{{ item.num }}】的回款</div>
                        <div class="msg-main" v-else-if="item.type_id == 10">【{{item.num}}】该笔发票申请未绑定回款单号，请及时绑定回款信息</div>
                        <div class="msg-main" v-else-if="item.type_id == 36">【{{item.charge_admin}}】提交【{{item.num}}】{{item.address}}的合同已更新，请及时确认 </div>
                        <div class="msg-main" v-else-if="item.type_id == 37">【{{item.num}}】的房号电子合同已确认，【{{item.work_num}}】的外勤工单待流转</div>
                        <div class="msg-main" v-else-if="item.type_id == 39">【{{item.num}}】续签时，未检索到原房号地址，请及时维护</div>
                        <div class="msg-main" v-else-if="item.type_id == 40">【{{item.num}}】未上传合同，请及时上传</div>
                        <div class="msg-main" v-else>{{ item.first_admin?item.first_admin.name:'-' }}提交了{{ item.num }}审批，请及时处理</div>
                    </div>
                    <div class="none" v-if="msgList.length == 0">
                        <img src="@/assets/image/none@2x.png" alt="">
                        <span>暂无数据</span>
                    </div>
                </div>
                <div class="msg-list " v-if="actMsgIndex == 1">
                   <div v-for="(item, index) in noticeList" :key="index" class="msg hover" @click="toNotice(item)">
                        <div class="report" style="color: #6B6D77;"><span class="msg-point"></span>
                            {{ item.create_admin?.name }}于{{ item.create_time }}发布了{{ item.title }}公告，请及时查看</div>
                    </div>
                    <div class="none" v-if="noticeList.length == 0">
                        <img src="@/assets/image/none@2x.png" alt="">
                        <span>暂无数据</span>
                    </div>
                </div>
                <div class="msg-list" v-if="actMsgIndex == 2">
                    <div v-for="(item, index) in systemList" :key="index" class="msg1">
                        <div class="msg1-main">{{ item.content }}</div>
                        <div class="msg1-date">{{ item.create_time }}</div>
                    </div>
                    <div class="none" v-if="systemList.length == 0">
                        <img src="@/assets/image/none@2x.png" alt="">
                        <span>暂无数据</span>
                    </div>
                </div>
                <div class="msg-bottom">
                    <div class="msg-more handel hover" @click="toMore">查看更多>></div>
                    <div class="msg-clear handel hover" v-if="actMsgIndex == 2">
                        <div class="img1">
                            <local-svg iconClass="delete"></local-svg>
                        </div>
                        <span @click="clearSystem">清空</span>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="" :visible.sync="reportDialog" width="60vw" class="report-dialog" append-to-body>
            <div class="report-dialog-mian">
                <p class="report-title">{{ report.title }}</p>
                <div class="line"></div>
                <div style="overflow: auto;margin-top: 24px;max-height:58vh;min-height:45vh;padding: 0 36px;">
                    <div class="report-name">公告内容：</div>
                    <div class="report-main" v-html="setHtml(report.content)"></div>
                    <div class="file-box" v-if="report?.bind_files?.length>0">
                        <div class="file-name">附件：</div>
                        <div class="filelist">
                            <div class="fileline hover" v-for="(item, index) in report.bind_files" :key="index"
                                @click="seeFile(item)">
                                <div>
                                    <local-svg iconClass="file" class="icon"></local-svg>
                                    <span class="name">{{ item.file_info?.title }}</span>
                                </div>
                                <!-- <div class="close" @click="delFile(index)">
                                    <local-svg iconClass="close" class="closeicon"></local-svg>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btnpart button-part">
                   <el-button class="cancel" v-if="report.should_read == 1" @click="noticeReadFun">我知道了</el-button>
                   <el-button class="confirm" :class="{'disabled':number > 0 }" v-if="report.should_read==2" @click="noticeReadFun">我已阅读并知晓<span v-if="number > 0">（{{ number }}s）</span></el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { message, readmsg, readsystem, clearmessage, clearreport, remindlist } from '@/api/common'
import { noticedetail,msglist,noticelist,todolist , notRead ,readRecord } from '@/api/message'
import vm from '@/assets/js/closeNav'
import { Loading } from 'element-ui';
export default {
    name: "Header",
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
        navList:{
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            report: {
                title: '',
                content: ''
            },
            form:{
                type:[]
            },
            typeList:[
                { "id": 6, "title": "成本支出-确认提交票据" },
                { "id": 7, "title": "开票管理" },
                { "id": 10, "title": "开票回款单号" },
                { "id": 11, "title": "完善房号信息" },
                { "id": 12, "title": "更新客户名称" },
                { "id": 13, "title": "房号提醒" },
                { "id": 14, "title": "新建外勤工单" },
                { "id": 15, "title": "外勤工单流转" },
                { "id": 16, "title": "问题反馈" },
                { "id": 17, "title": "外勤工单驳回" },
                { "id": 23, "title": "客户管理" },
                { "id": 24, "title": "客户管理" },
                { "id": 25, "title": "用户注册" },
                { "id": 26, "title": "完善房号回款单号" },
                { "id": 27, "title": "我的需求" },
                { "id": 28, "title": "专事专办" },
                { "id": 29, "title": "确认房号回款" },
                { "id": 31, "title": "项目工程" },
                { "id": 32, "title": "行政支出" },
                { "id": 33, "title": "行政支出-未提交票据" },
                { "id": 34, "title": "行政支出-确认提交票据" },
                { "id": 35, "title": "完善成本支出回款" },
                { "id": 36, "title": "房号合同确认" },
                { "id": 37, "title": "外勤流转" },
                { "id": 38, "title": "房屋合同" },
                { "id": 39, "title": "合同续签" },
                { "id": 40, "title": "合同附件" }
            ],
            total: '',
            msgList: [],
            messageDialog: false,
            msgTabList: [
                { name: '待办事项', num: 0 },
                { name: '系统公告', num: 0 },
                { name: '系统消息', num: 0 },
            ],
            actMsgIndex: 0,
            act_nav: 2,
            info: {
                avatar: require('../assets/image/user.png'),
                name: this.$store.state.username,
            },
            actindex: 0,
            isClose: false,
            tabList: [
            ],
            visible: true,
            moreList: [
                // {name:'个人中心',path:'/personal'},
                // {name:'费用申请',path:'/'},
            ],
            mineList: [
                { name: '个人中心', path: '/personal' },
                { name: '退出登录', path: '/personal' },
            ],
            totalMessage: '',
            noticeList: [],
            systemList: [],
            timer: null,
            reportDialog: false,
            NewYear:this.$New_Year,
            number:10,
            now_timer:null,
        };
    },
    mounted() {
        this.getMsg()
        this.act_nav = localStorage.getItem('system_index') ? localStorage.getItem('system_index') : 2
        this.beginGet()
        this.getTypeList()
        // this.getTab()
    },
    methods: {
        // changePage(e){
        //     this.act_nav = e
        // },
        closeDrawer(){
            this.$set(this.form,'type',[])
        },
        getTypeList(){
            console.log(1)
            remindlist().then(res=>{
                this.typeList = res.data
            })
        },
        // getMindList(){
        //     let data = {
        //         type:this.form.type.toString()
        //     }
        //     remindlist(data).then(res=>{
        //         console.log(res)
        //     })
        // },
        changeSystem(item) {
            if (item.type == 1) {
                if(item.path == '/projmgmt/index'||item.path == '/menhu/knowHouse'){
                    Loading.service({
                        text: "加载中...."
                    });
                    setTimeout(()=>{
                        Loading.service().close()
                    },2000)
                }
                this.act_nav = item.id
                this.$emit('nav', item.id)
                vm.$emit('nav', item)
                localStorage.setItem('system_index', item.id)
                this.$router.push({
                    path: item.path
                })
            } else if (item.type == 2) {
                window.open(`${item.url}?p_token=${localStorage.getItem('token')}`, '_blank')
            } else {
                if (item.id == 5) {
                    window.open(`${item.url}`, '_blank')
                }
            }
        },
        noticeReadFun() {
            if (this.report.should_read == 2 && this.number > 0) {
                return
            }
            readRecord({
                id: this.report.id
            }).then(res => {
                this.reportDialog = false
                this.getMsg()
            })
        },
        showReport() {
            if (this.reportDialog) {
                return
            }
            if (this.noticeList?.length > 0) {
                noticedetail({
                    id: this.noticeList[0].id
                }).then(res => {
                    if (res.code == 200) {
                        this.report = res.data
                        this.reportDialog = true
                        if(this.report.should_read == 2){
                            this.startTiming()
                        }
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        toPersonal() {
            this.$router.push({
                path: '/terrace/personal'
            })
            this.act_nav = 10
            this.$emit('nav', 10)
            localStorage.setItem('system_index', 10)
        },
        clearSystem() {
            if (this.actMsgIndex == 2) {
                clearmessage().then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.systemList = []
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            } else {
                let ids = []
                this.noticeList.forEach(item => {
                    ids.push(item.id)
                })
                let data = {
                    id: ids.toString()
                }
                clearreport(data).then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        this.getMsg()
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            }

        },
        beginGet() {
            this.timer = setInterval(() => {
                this.getMsg()
            }, 60000);
        },
        toMore() {
            let index = this.actMsgIndex
            if (index == 0) {
                this.$router.push({
                    name: 'todolist'
                })
            } else if (index == 1) {
                this.$router.push({
                    name: 'notice',
                    query: {
                        type: 'read'
                    }
                })
            } else {
                this.$router.push({
                    name: 'message'
                })
            }
            this.act_nav = 6
            this.$emit('nav', 6)
            localStorage.setItem('system_index', 6)
            this.messageDialog = false
        },
        changePage(e){
            this.act_nav = e
            this.$emit('nav', e)
            localStorage.setItem('system_index', e)
        },
        toExamine(value, key, msg) {
          console.log('跳转key',value, key, msg)
            let source = 1
            let work_id = msg.work_id ? msg.work_id : msg.data_id ? msg.data_id : ''
            let data = {
                type: key,
                data_id: value
            }
            readmsg(data).then(res => {
                if (this.actMsgIndex == 0) {
                    //1.合同  2.回款  3.费用申请  4.房屋回款 5.未提交票据  6.财务确认票据提交   7.开票管理  10.完善回款   11.完善房号
                    // 12.客户名称审核   13外勤   14 流转   15问题返回  16 驳回   17 延期
                    if (key == 1) {
                        this.$router.replace({
                            path: '/contract',
                            query: {
                                id: value,
                                type: 'examine',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 2) {
                        this.$router.replace({
                            path: '/contractback',
                            query: {
                                id: value,
                                type: 'examine',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 3) {
                        this.$router.replace({
                            path: '/costOut',
                            query: {
                                id: value,
                                type: 'examine',
                                timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 4) {
                        this.$router.replace({
                            path: '/housecollection',
                            query: {
                                id: value,
                                type: 'examine',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 7) {
                        this.$router.replace({
                            path: '/openbill',
                            query: {
                                id: value,
                                type: 'examine',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 5) {
                        this.$router.replace({
                            path: '/costOut',
                            query: {
                                id: value,
                                type: 'examinebill',
                                timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 6) {
                        this.$router.replace({
                            path: '/costOut',
                            query: {
                                id: value,
                                type: 'examineconfirm',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 10) {
                        this.$router.replace({
                            path: '/openbill',
                            query: {
                                id: value,
                                type: 'improvebill',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 11) {
                        this.$router.replace({
                            path: '/house',
                            query: {
                                id: value,
                                type: 'improvesell',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(3)
                    }
                    else if (key == 24) {
                        this.$router.replace({
                            path: '/custom',
                            query: {
                                id: msg.client_id,
                                type: 'confirm',
                                out_name: msg.num,
                                remind_id: msg.id,
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(1)
                    }else if (key == 23) {
                        this.$router.replace({
                            path: '/custom',
                            query: {
                                id: value,
                                type: 'change',
                                out_name: msg.remind_other ? msg.remind_other : '1',
                                remind_id: msg.id,
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(1)
                    }else if(key == 14){
                        sessionStorage.setItem('outwork', JSON.stringify({ id: work_id, type: 'examine', source: source }))
                       if(msg.source===1){
                         this.$router.replace({
                           path:'/field/list',
                           query:{
                             key:work_id,
                             timestamp: Date.now()
                           }
                         })
                       }else{
                         this.$router.replace({
                           path:'/field/list2',
                           query:{
                             key:work_id,
                             timestamp: Date.now()
                           }
                         })
                       }

                        this.changePage(3)
                    }else if(key == 15){
                        sessionStorage.setItem('outwork', JSON.stringify({ id: work_id, type: 'flow', source: source }))
                      if(msg.source===1){
                        this.$router.push({
                          path:'/field/list',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }else{
                        this.$router.push({
                          path:'/field/list2',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }
                        this.changePage(3)
                    }else if(key == 16){
                        sessionStorage.setItem('outwork', JSON.stringify({ id: work_id, type: 'back', source: source }))
                      if(msg.source===1){
                        this.$router.push({
                          path:'/field/list',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }else{
                        this.$router.push({
                          path:'/field/list2',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }
                        this.changePage(3)
                    }else if(key == 17){
                        sessionStorage.setItem('outwork', JSON.stringify({ id: work_id, type: 'refuse', source: source }))
                      if(msg.source===1){
                        this.$router.push({
                          path:'/field/list',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }else{
                        this.$router.push({
                          path:'/field/list2',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }
                        this.changePage(3)
                    }else if(key == 18){
                        sessionStorage.setItem('outwork', JSON.stringify({ id: work_id, type: 'apply', source: source }))
                      if(msg.source===1){
                        this.$router.push({
                          path:'/field/list',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }else{
                        this.$router.push({
                          path:'/field/list2',
                          query:{
                            key:work_id,
                            timestamp: Date.now()
                          }
                        })
                      }
                        this.changePage(3)
                    }else if(key==25){
                      this.$router.push({
                        path:'/terrace/membert',
                        query:{
                          key:value,
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(7)
                    }else if(key==27){
                      this.$router.push({
                        path:'/projmgmt/myprojmgmt',
                        query:{
                          key:msg.num,
                          need_id:msg.need_id,
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(12)
                    }else if(key==26){
                      this.$router.push({
                        path:'/house',
                        query:{
                          key:msg.num,
                          cid:msg.contract_id,
                          rid:msg.data_id,
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(3)
                    }else if(key==28){
                      this.$router.push({
                        path:'/specially',
                        query:{
                            id:msg.demand_id
                        }
                      })
                      this.changePage(3)
                    }
                    else if (key == 29) {
                        this.$router.push({
                            path: '/contractback',
                            query: {
                                id: value,
                                type: 'examine',
                              timestamp: Date.now()
                            }
                        })
                        this.changePage(2)
                    }
                    else if (key == 31) {
                      this.$router.push({
                        path: '/upload-project',
                        query: {
                          id: value,
                        }
                      })
                      this.changePage(12)
                    }
                    else if (key == 32) {
                      this.$router.push({
                        path: '/adminExp',
                        query: {
                          id: value,
                          type: 'detail',
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(2)
                    }
                    else if (key == 33) {
                      this.$router.push({
                        path: '/adminExp',
                        query: {
                          id: value,
                          type: 'examinebill',
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(2)
                    }
                    else if (key == 34) {
                      this.$router.push({
                        path: '/adminExp',
                        query: {
                          id: value,
                          type: 'examineconfirm',
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(2)
                    }
                    else if (key == 35) {
                      this.$router.push({
                        path: '/costOut',
                        query: {
                          id: value,
                          type: 'wanshan',
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(3)
                    }
                    else if (key == 36) {
                      this.$router.push({
                        path: '/house',
                        query: {
                          id: value,
                          type: msg.address == '暂无' || msg.address == '等待负责人生成房号地址'|| msg.address == '未检索到新签房号地址，需负责人自行维护' ? 1 : 2,
                          timestamp: Date.now()
                        }
                      })
                      this.changePage(3)
                    }
                    else if(key == 37){
                      sessionStorage.setItem('outwork', JSON.stringify({ id: work_id, type: 'examine', source: source }))
                      this.$router.push({
                        path:'/field/list',
                        query:{
                          key:msg.work_id
                        }
                      })
                      this.$emit('nav',3)
                    }
                    else if(key == 38){
                      this.$router.push({
                        path:'/housecontract',
                        query:{
                            id:value,
                            type: 'examine',
                            timestamp: Date.now()
                        }
                      })
                      this.$emit('nav',2)
                    }
                    else if(key == 39){
                      this.$router.push({
                        path:'/house',
                        query:{
                            timestamp: Date.now()
                        }
                      })
                      this.$emit('nav',3)
                    }
                    else if(key == 40){
                      this.$router.push({
                        path:'/contract',
                        query:{
                            id:value,
                            timestamp: Date.now(),
                            type:'perfect'
                        }
                      })
                      this.$emit('nav',2)
                    }
                }
                this.getMsg()
                this.messageDialog = false
            })
        },
        toNotice(item) {
            this.$router.push({
                name: 'notice',
                query: {
                    type: 'detail',
                    id: item.id,
                  timestamp: Date.now()
                }
            })
            this.messageDialog = false
            this.changePage(6)
            this.getMsg()
        },
        getMsg(e) {
            let data = {
                page:1,
                limit: e ? 50 : '20',
                type:this.form.type.toString()
            }
            message(data).then(res => {
                if(e){
                    this.msgList = res.data.remind.table
                    this.msgTabList[0].num = res.data.remind.total
                }else{
                    if(this.form.type && this.form.type.length == 0){
                        this.msgList = res.data.remind.table
                        this.msgTabList[0].num = res.data.remind.total
                    }
                }
                this.noticeList = res.data.notice
                this.msgTabList[1].num = res.data.notice.length
                this.systemList = res.data.system.system
                this.msgTabList[2].num = res.data.system.system_total
                this.totalMessage = res.data.total_num
                this.showReport()
            })
        },
        getMessageList(){
            let data = {
                is_read:11,
                page:1,
                count:999,
                founder: '',
                way: '',
                recipient:''
            }
            msglist(data).then(res=>{
                this.systemList = res.data.table
                this.msgTabList[2].num = res.data.total
            })
        },
        changTab(index) {
            if (index == 2) {
                let data = {
                    is_read: 1
                }
                readsystem(data).then(res => {
                    this.msgTabList[2].num = 0
                    this.totalMessage = Number(this.msgTabList[1].num + this.msgTabList[2].num + this.msgTabList[0].num).toFixed(0)
                })
            }
            this.actMsgIndex = index
        },
        refsh() {
            // console.log(111111);
            this.$router.go(0);
        },
        async examine() {
            await this.getMsg()
            this.messageDialog = true

        },
        cleanTab() {
            this.tabList = []
        },
        toPage(item) {
            this.$router.replace(item.path)
        },
        closeTab(index) {
            this.tabList.splice(index, 1)
            if (this.actindex == index) {
                this.actindex = 0
                this.$router.replace(this.tabList[this.actindex].route)
            }
        },
        changeTab(item, index) {
            this.$router.push(item.route)
            this.actindex = index
        },
        // closeNav() {
        //     if (this.isClose) {
        //         this.isClose = false
        //     } else {
        //         this.isClose = true
        //     }
        //     let type = this.isClose
        //     vm.$emit("closetype", type)
        // },
        // getTab() {
        //     vm.$on('closeobj', value => {
        //         var a = this.tabList.indexOf(value, 0)
        //         if (a >= 0) {
        //             this.tabList.splice(a, 1)
        //             this.tabList.unshift(value)
        //         } else {
        //             this.tabList.unshift(value)
        //             if(this.tabList.length>8){
        //                 this.tabList.splice(9,1)
        //             }
        //             this.actindex = 0
        //         }
        //     })
        // },
        logout() {
            let password = localStorage.getItem('password')
            let phone = localStorage.getItem('phone')
            localStorage.clear()
            localStorage.setItem('password', password)
            localStorage.setItem('phone', phone)
            this.$router.push({
                path: '/login'
            })
        },
        setHtml(str) {
            return str
                .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
                .replace(/&amp;nbsp;/g, "")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, "\"")
                .replace(/&#39;/g, "\'")
        },
        seeFile(item) {
            let path = item.file_info?.file_path
            if (path) {
                window.open(path, '_blank')
            }
        },
        getFileName(url) {
            return url.split("/").slice(-1)[0]
        },
        startTiming() {
            this.number = 10
            this.now_timer = setInterval(() => {
                if (this.number === 0) {
                    clearInterval(this.now_timer);
                } else {
                    this.number = this.number - 1
                }
            }, 1000)
        }
    },
    destroyed() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        if (this.now_timer) {
            clearInterval(this.now_timer);
        }
    }
}

</script>

<style lang="scss">
.el-popover {
    min-width: 96px !important;
}

.showbox {
    padding: 8px 0;
}

.el-drawer__open .el-drawer.rtl {
    width: 480px !important;
}

.messageBox {
    padding: 0 !important;

    // width: 480px;
    .el-badge__content {
        background-color: #F33232 !important;
    }

    .el-badge__content {
        border: none;
        font-weight: normal !important;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        min-width: 8px;
    }

    .el-badge__content.is-fixed {
        right: 0 !important;
    }
}

.iconlist {
    .el-badge__content {
        background-color: #F33232 !important;
    }

    .el-badge__content {
        border: none;
        font-weight: normal !important;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        min-width: 8px;
    }

    .el-badge__content.is-fixed {
        right: 37px !important;
    }
}

.report-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
    
    .el-dialog{
        margin-top: 5vh!important;
    }

    .el-dialog__header {
        display: none;
    }

    .report-dialog-mian {
        padding: 0;
        border-top: 4px solid #CD0000;
        border-radius: 4px 4px 0px 0px;
        box-sizing: border-box;
        padding: 36px 0;

        .report-title {
            width: 100%;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            color: #CD0000;
            line-height: 28px;
            padding: 0 36px;
        }

        .line {
            margin: 40px 36px 0;
            border-bottom: 1px dashed #E2E7EE;
        }

        .report-name {
            font-weight: 400;
            font-size: 14px;
            color: #9A9EAA;
            line-height: 14px;
            text-align: left;
        }

        .report-main {
            margin-top: 12px;
            // max-height: 418px;
            padding: 16px 24px;
            font-size: 14px;
            color: #353940;
            line-height: 22px;
            position: relative;
            text-align: left;
            word-break: break-all;
            box-sizing: border-box;
            background: #FAFAFB;
            border-radius: 8px 8px 8px 8px;
            overflow-y: auto;
            img {
                width: auto !important;
                max-width: 100% !important;
            }
        }

        .file-box {
            margin-top: 24px;
            display: flex;

            .file-name {
                flex: none;
                margin-right: 5px;
                font-weight: 400;
                font-size: 14px;
                color: #9A9EAA;
                line-height: 28px;
            }

            .filelist {
                width: 100%;
                height: auto;
                overflow-y: auto;
                box-sizing: border-box;

                .fileline {
                    display: flex;
                    height: 28px;
                    border-radius: 4px;
                    background: #F4F7FC;
                    width: 100%;
                    align-items: center;
                    margin-bottom: 6px;
                    padding: 0 12px 0 8px;
                    justify-content: space-between;
                    box-sizing: border-box;

                    .icon {
                        margin-right: 7px;
                        width: 12px;
                        height: 14px;
                    }

                    .name {
                        font-size: 12px;
                        color: #474952;
                    }

                    .close {
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        background: rgba(63, 69, 124, 0.1);
                        display: none;
                        align-items: center;
                        justify-content: center;

                        .closeicon {
                            width: 8px;
                            height: 8px;
                            fill: #B0B1B9;
                        }
                    }

                    .close:hover {
                        background: rgba(44, 87, 255, 0.2) !important;

                        .closeicon {
                            fill: #2C57FF !important;
                        }
                    }
                }

                .fileline:hover {
                    background: #EDF3FE !important;

                    .close {
                        display: flex;
                    }
                }
            }

        }


        .button-part {
            margin-top: 36px;
            text-align: center;

            .confirm {
                padding: 0 24px !important;

                &.disabled {
                    border-color: transparent !important;
                    background: rgba(29, 120, 254, 0.5) !important;
                    color: #FFFFFF !important;
                    cursor: not-allowed;
                }
            }
        }
    }

    .el-dialog__body {
        padding: 0 !important;
    }
}
</style>
<style lang="scss" scoped>
* {
    text-align: center;
    box-sizing: border-box;
}

.box {
    width: 100%;
    height: 72px;
    background: #fff;
    padding: 0;
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    padding: 0 40px;
    align-items: center;
    position: relative;
    z-index: 999;

    .messageBox::-webkit-scrollbar {
        display: none;
    }

    .line {
        display: flex;
        align-items: center;

        img {
            width: 190px;
            height: 40px;
        }

        // .icon {
        //     font-size: 20px;
        // }

        // .tab-list {
        //     display: flex;
        //     margin-left: 30px;

        //     .list-box {
        //         height: 60px;
        //         color: #B0B1B9;
        //         font-size: 14px;
        //         line-height: 16px;
        //         width: 108px;
        //         display: flex;
        //         align-items: center;
        //         border-top: white 4px solid;

        //         .box-msg {
        //             display: flex;
        //             justify-content: center;
        //             height: 16px;
        //             width: 100%;
        //             border-right: 1px solid #e6e6e6;

        //             .box-close {
        //                 width: 14px;
        //                 height: 14px;
        //                 background: #E6E6E6;
        //                 display: flex;
        //                 border-radius: 50%;
        //                 margin-left: 8px;

        //                 .img {
        //                     width: 6px;
        //                     height: 6px;
        //                     margin: auto;
        //                 }
        //             }
        //         }

        //     }

        //     .list-box:last-child {
        //         .box-msg {
        //             border: none;
        //         }
        //     }

        //     .acttab {
        //         color: #2C57FF !important;
        //         background: #F4F7FC;
        //         border-top: #2C57FF 4px solid;

        //         .box-close {
        //             background: rgba(44, 87, 255, 0.2) !important;

        //             .svg-icon {
        //                 fill: #2C57FF !important;
        //             }
        //         }

        //         .box-msg {
        //             border-right: 1px solid F4F7FC;
        //         }
        //     }
        // }
    }

    .tabline {
        width: auto;
        display: flex;
        align-items: center;
        width: auto;

        .tab-item {
            padding: 0 20px;
            border-right: 1px solid #BBCDEB;
            font-size: 16px;
            color: #66799C;
            line-height: 19px;
            word-break: keep-all;
            white-space: nowrap;
        }

        .tab-item:hover {
            color: #1D78FE;
        }

        .active {
            color: #1D78FE;
            font-weight: bold;
        }
        .hide{
            display: none;
        }
        .tab-item:last-child {
            border-right: none;
        }
    }
    .tablineYear{
      .tab-item {
        color: white ;
      }
      .tab-item:hover {
        color: white;
      }
      .active {
        color: white;
      }
    }

    .line2 {
        width: 300px;
        height: 60px;
        display: flex;
        flex-direction: row-reverse;

        .user {
            width: auto;
            // border-left: #F0F1F5 solid 1px;
            height: 100%;
            // padding: 0 0 0 30px;
            text-align: right;
            display: flex;
            align-items: center;

            .user-avatar {
                width: 36px;
                height: 36px;
                margin-right: 14px;
            }

            .user-show {
                width: 10px;
                height: 5px;
                margin-left: 6px;
            }

            .button {
                background: transparent;
                border: none;
                outline: none;
                font-size: 14px;
                line-height: 16px;
                white-space: nowrap // width: auto;
                    // display: flex;
                    // flex-wrap: nowrap;
            }
        }

        .avatar-handel {
            button {
                color: #B0B1B9;
            }

            .svg-icon {
                fill: #B0B1B9;
            }
        }

        .avatar-handel:hover {
            button {
                color: #1D78FE !important;
            }

            .svg-icon {
                fill: #1D78FE !important;
            }
        }

        .iconlist {
            display: flex;
            align-items: center;
            flex-direction: row-reverse;

            .more-box {
                height: 20px;
                display: flex;
                align-items: center;
            }

            .list-image {
                width: 20px;
                height: 18px;
                margin-right: 30px;
            }

            .msg {
                width: 18px;
                height: 20px;
            }

            // .more{
            //     width: 20px;
            //     height: 4px;
            // }
            .button {
                background: transparent;
                background-size: 100% 100%;
                border: none;
                outline: none;
            }

        }
    }

  .line2Year {


    .avatar-handel {
      button {
        color: #B0B1B9;
      }

      .svg-icon {
        fill: #B0B1B9;
      }
    }

    .avatar-handel:hover {
      button {
        color: white !important;
      }

      .svg-icon {
        fill: white !important;
      }
    }

    .iconlist{
      .list-image{

      }
    }

  }

}
.boxYear{
  background-image: url("@/assets/image/newyear/headerbg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-shadow: 0px 1px 4px 0px rgba(162, 37, 17, 1);
}
.showbox {
    .showbox-list {
        width: 100%;
        height: 36px;
        color: #9CA3B6;
        line-height: 36px;
        font-size: 14px;
    }
}

.acthaer {
    transform: rotate(180deg);
}


.message-info {
    height: 100vh;
    display: flex;
    flex-direction: column;

    .headtab {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        padding: 28px 0 0px 0;

        .tab-box {
            display: flex;
            justify-content: space-between;
            width: 100%;
            font-size: 14px;
            border-bottom: 1px solid #F0F1F5;
            box-sizing: content-box;
            height: 32px;

            .tab {
                color: #B0B1B9;
                height: 100%;
                width: 180px;
            }

            .tab:hover {
                color: #1D78FE;
            }

            .acttab {
                font-weight: bold !important;
                color: #1D78FE !important;
                border-bottom: 2px solid #1D78FE !important;
                width: 180px;
                height: calc(100% + 2px);
            }
        }
    }
    .select-part{
        width: 100%;
        box-sizing: border-box;
        padding: 26px 32px 10px;

    }
    .first-page.msg-list{
         .msg:first-child{
            padding-top: 6px;
         }
    }
    .msg-list {
        padding: 8px 31px 8px 48px;
        text-align: left;
        height: 100%;
        overflow-y: auto;
        .msg {
            padding: 16px 0;
            border-bottom: 1px #EAECF5 dashed;

            .msg-top {
                display: flex;
                justify-content: space-between;
                line-height: 22px;

                .msg-title {
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    position: relative;
                    color: #6B6D77;

                    .msg-point {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background: #F33232;
                        position: absolute;
                        left: -18px;
                    }
                }

                .msg-date {
                    font-size: 12px;
                    color: #B0B1B9;
                }
            }

            .msg-main {
                text-align: left;
                margin-top: 16px;
                color: #B0B1B9;
                font-size: 14px;
                line-height: 22px;
                word-break: break-all;
            }

            .report {
                text-align: left;
                color: #B0B1B9;
                font-size: 14px;
                line-height: 22px;
                position: relative;

                .msg-point {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #F33232;
                    position: absolute;
                    left: -18px;
                    top: 6px;
                }
            }
        }

        .msg:last-child {
            border: none;
        }

        .msg1 {
            padding: 16px 0;
            border-bottom: 1px #EAECF5 dashed;
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 22px;

            .msg1-main {
                text-align: left;
                width: 276px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                color: #6B6D77;
            }

            .msg1-date {
                font-size: 12px;
                color: #B0B1B9;
            }
        }

        .none {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                width: 75%;
            }

            span {
                margin-top: -10px;
                color: #D0D0D2 !important;
                font-size: 14px;
                margin-bottom: 80px;
            }
        }
    }

    .msg-bottom {
        border-top: 1px solid #F0F1F5;
        width: 100%;
        height: 70px;
        padding: 20px 30px 30px;
        flex: none;
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        box-sizing: border-box;

        .msg-more {
            font-size: 14px;
        }

        .msg-clear {
            font-size: 14px;
            display: flex;
            align-items: center;

            .img1 {
                margin-right: 8px;
            }
        }
    }

}
</style>
<style lang="scss">
.report-dialog-mian {
    .report-main {
        table {
            border: 1px solid #ccc;

        }

        table td,
        table th {
            border: 1px solid #ccc;

        }

        table th {
            border-bottom: 2px solid #ccc;
        }
    }

    img {
        width: 100%;
    }
}
.line2Year {

  .iconlist{
    .list-image{
      fill:white !important;
    }
    .list-image:hover{
      fill:white !important;
    }
  }

}
.sjys{
  color: white !important;
  fill: white !important;
}
</style>
